/**
 * Environment configuration loader
 * Handles API URL based on environment for client-side applications
 */
class EnvironmentConfig {
    constructor() { }
    static getInstance() {
        if (!EnvironmentConfig.instance) {
            EnvironmentConfig.instance = new EnvironmentConfig();
        }
        return EnvironmentConfig.instance;
    }
    /**
     * Get API URL based on environment
     * @returns API URL for current environment
     */
    getApiUrl() {
        return (process.env.REACT_APP_CDT_APP_PUBLIC_API_URL ||
            "https://us-central1-cdt-america.cloudfunctions.net/cdtPublicApi/v1");
    }
    /**
     * Check if running in production
     * @returns True if in production environment
     */
    isProduction() {
        return process.env.NODE_ENV === "production";
    }
    /**
     * Check if running in development
     * @returns True if in development environment
     */
    isDevelopment() {
        return process.env.NODE_ENV === "development" || !this.isProduction();
    }
}
// Export singleton instance
export default EnvironmentConfig.getInstance();
